import React from 'react';
import { Modal } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import ModalTitleBar from '../ModalTitleBar';
import ConcurrentSessionModalContainer from './ConcurrentSessionModalContainer';

const KickCallbackModal = ({
  open,
}: {
  open: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <Modal open={open} style={{ zIndex: 500000 }}>
      <ConcurrentSessionModalContainer>
        <ModalTitleBar>{t('concurrent_session.kick_callback.title', 'Concurrent Login Detected')}</ModalTitleBar>
        {t('concurrent_session.kick_callback.message', 'You have already logged from another device. Redirecting you back to the landing page...')}
      </ConcurrentSessionModalContainer>
    </Modal>
  );
};

export default KickCallbackModal;
